<section class="more-analyst-research">
  <div class="heading">
    More Analyst Research
  </div>
  <div class="analyst-list">
    <div *ngFor="let data of moreAnalyst">
      <div class="analyst-row">
        <div class="pub-date">
          {{ data.publication_date | date: "d-MMM" }}
        </div>
        <div class="doc-title">
          <a (click)="researchRedirect('/research_document/' + data.id)">
            {{ data.title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
